// -- == //
import AppLoading from 'components/appLoading';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
import NotificationCreateTabs from './lib/tabs';

export default function NotificationCreatePage() {
  const { eventCreate, eventUpload, contributorUploadQuest } = useTypedSelector((state: any) => state.Events);
  const { departments } = useTypedSelector((state) => state.Departments);
  const { floorList } = useTypedSelector((state) => state.Floors);
  const { userList } = useTypedSelector((state) => state.Users);

  return (
    <S.Container>
      <PageTitle title="Create Notification" />
      <NotificationCreateTabs departments={departments.data} floors={floorList.data} userList={userList.data} />

      <AppLoading
        loading={
          eventCreate.loading ||
          eventUpload.loading ||
          departments.loading ||
          floorList.loading ||
          contributorUploadQuest.loading
        }
      />
    </S.Container>
  );
}
